import { queryClient } from "@/queryClient"
import type { Acquirer } from "../sharedTypes/merchants"
import type { MerchantCurrencyCode } from "@/utils/currency"

export type CreateMerchantParams = {
  businessName: string

  tpReference: string
  merchantCategoryCode: string | null
  currency: MerchantCurrencyCode

  customerName: string
  customerEmail: string
  customerPhone: string

  addressLine1: string | null
  addressLine2: string | null

  cardstreamMerchantId: string | null
  cardstreamMerchantSecret: string | null

  paxMerchantId: string | null
  acquirer: Acquirer
  evoConfig: {
    gratuityIsAvailable: boolean
  }

  hasSalesModule: boolean
  hasDonationsModule: boolean
  hasBeepaidOrderModule: boolean
  hasBeepaidGoModule: boolean

  isFromBackbook: boolean
  isDemoMerchant: boolean

  demoMenuId: number | null
}

export const createMerchant = async (
  params: CreateMerchantParams
) => {
  await api.post("/merchants/new/", {
    body: params,
  })

  queryClient.invalidateQueries({
    queryKey: [MERCHANTS_QUERY_KEY],
  })
  return
}
